import { element } from 'protractor';
import { Component, Input, OnInit } from '@angular/core';
import { Headers } from '@angular/http';
import { HttpClientService } from 'app/Services/http-client.service';
import { SuccessCompassDataService } from 'app/Services/success-campass.service';
import { AppSettings } from 'app/app-settings';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-calendar-week-view',
  templateUrl: './calendar-week-view.component.html',
  styleUrls: ['./calendar-week-view.component.css']
})
export class CalendarWeekViewComponent implements OnInit {
  cdn_url: string = AppSettings.cdnUrl;
  startDate: any = null;
  allDatesData: Array<any> = [];
  limits = {
    startDate: DateTime.now(),
    endDate: DateTime.now()
  }
  @Input() data: any = {};
  dates: Array<DateTime> = [];
  days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  calendarData: any = [];
  arrowEnabled = {
    left: true,
    right: true
  };

  iconTimeUrl = AppSettings.cdnUrl + "assets/images/ico-list.svg";
  iconNextUrl = AppSettings.cdnUrl + "assets/images/ico-next-black.svg";
  iconPrevUrl = AppSettings.cdnUrl + "assets/images/ico-prev-black.svg";


  constructor(private httpClientService: HttpClientService, private successCompassDataService:SuccessCompassDataService){}

  getMonth(date){
    return (this.dates[0].toFormat('dd MMM') + ' - ' + this.dates[this.dates.length-1].toFormat('dd MMM'));
  }

  goToToday(){
    this.startDate = this.successCompassDataService.now(this.data.userTimezone);
    this.calendarMonthDates();
  }

  setMonth(inc, flag) {
    if(flag){
      this.arrowEnabled = {
        left: true,
        right: true
      }
      let nextDate = this.startDate.plus({'days': (inc*7)});
      if((inc == 1 && nextDate.startOf('week', {useLocaleWeeks: true}).startOf('day')<=DateTime.fromFormat(this.limits.endDate,'yyyy LLL dd').startOf('day')) || (inc == -1 && nextDate.endOf('week', {useLocaleWeeks: true}).startOf('day')>=DateTime.fromFormat(this.limits.startDate,'yyyy LLL dd').startOf('day'))){
        this.startDate = nextDate;
        this.calendarMonthDates();
      }else{
        if(inc == 1){
          this.arrowEnabled.right = false;
        }else{
          this.arrowEnabled.left = false;
        }
      }
    }
  }

  ngOnInit(): void {
    this.data.userTimezone = (this.data.userTimezone && this.data.userTimezone.timezone)?this.data.userTimezone.timezone:DateTime.now().zoneName;
    this.dataFormat();
  }

  goToStudyPlan(){
    window.open(AppSettings.gfePSPUrl, '_blank');
  }
  isSameMonth(date){
    return true;
  }
  getClassBackground(dataObj,type){
    let className = '';
    if(dataObj.data){
      if(dataObj.data.header.color==='blue'){
        if(dataObj.data.activity.time == 0 && type == 'line'){
          className = 'blue-strip-line';
        }else{
          className = 'bg-blue';
        }
      }else if(dataObj.data.header.color==='orange'){
        if(dataObj.data.activity.time == 0 && type == 'line'){
          className = 'orange-strip-line';
        }else{
          className = 'bg-orange';
        }
      }
    }
    return className;
  }
  dataFormat(){
    this.startDate = null;
    this.allDatesData = [];
    let date = DateTime.now();
    let course = '';
    let color = 'blue';
    let today = this.successCompassDataService.now(this.data.userTimezone);
    let firstTaskChecked = false;+

    this.data.primaryTasks.forEach((primaryTask, index) => {
      let endDateOfTask = this.successCompassDataService.dateObjectFromMillis(primaryTask.taskEndDate,this.data.userTimezone).startOf('day');
      let todayDate = today.startOf('day');
      let courseName = '';
      let focus = false;
      let isNonCourse = (primaryTask.tags.PLATFORM.includes('SCHOL')) || (!primaryTask.tags.COURSE);
      if(primaryTask.tags.LABEL && primaryTask.tags.LABEL.length>0){
        courseName = primaryTask.tags.LABEL.toString();
      }else if(primaryTask.tags.COURSE && primaryTask.tags.COURSE.length>0){
        courseName = primaryTask.tags.COURSE.toString();
      }else{
        courseName = primaryTask.tags.SECTION.toString();
      }
      if(courseName != course){
        switch(color){
          case 'blue':
            color = 'orange';
            break;
          case 'orange':
           color = 'blue';
           break;
        }
      }
      if(!firstTaskChecked){
        if(primaryTask.status != 'COMPLETED' && primaryTask.status != 'COMPLETED_AUTO'){
          this.startDate = this.successCompassDataService.dateObjectFromMillis(primaryTask.taskStartDate,this.data.userTimezone);
          focus = true;
          firstTaskChecked = true;
        }
      }
      date = this.successCompassDataService.dateObjectFromMillis(primaryTask.taskStartDate,this.data.userTimezone);
      let dateValue = date.toFormat('yyyy LLL dd');
      this.allDatesData[dateValue] = {};
      let header = {
        name: (courseName == course)?'':courseName.replace(/_/g, ""),
        color: color
      };
      this.allDatesData[dateValue]['header'] = header;
      course = courseName;
      let isPrimaryTaskTimeAlloted = false;
      let taskDays = 0;
      primaryTask.subtasks.forEach((subtaskObj) => {
        if(subtaskObj.humanCommitment != 0){
          taskDays += 1;
        }
      });
      primaryTask.subtasks.forEach((subtask,subIndex) => {
        date = this.successCompassDataService.dateObjectFromMillis(subtask.taskStartDate,this.data.userTimezone);
        let dateIndex = date.toFormat('yyyy LLL dd');
        if(!(this.allDatesData[dateIndex] && this.allDatesData[dateIndex]['header'])){
          this.allDatesData[dateIndex] = {};
          let header = {
            name: '',
            color: color
          };
          this.allDatesData[dateIndex]['header'] = header;
        }
        let activity = {
          id: subtask.id,
          name: subtask.name,
          UTCDate: subtask.taskStartDate,
          time: subtask.humanCommitment,
          status: subtask.status,
          color: color,
          statusButtonClicked: false,
          statusTodayButtonClicked: false,
          isNonCourse: isNonCourse,
          isPending: false,
          timeAlloted: subtask.timeAlloted,
          timeWarning: false,
          timeWarningLastLine: true,
          overridenDayCommitment: subtask.overridenDayCommitment
        }
        if(subIndex === primaryTask.subtasks.length - 1 && todayDate > endDateOfTask && subtask.status != 'COMPLETED' && subtask.status != 'COMPLETED_AUTO'){
          activity.isPending = true;
        }
        if(subtask.timeAlloted != subtask.humanCommitment && primaryTask.status != 'COMPLETED' && primaryTask.status != 'COMPLETED_AUTO'){
          activity.timeWarning = true;
          if(taskDays == 1){
            activity.timeWarningLastLine = false;
          }
        }
        this.allDatesData[dateIndex]['activity'] = activity;
        this.allDatesData[dateIndex]['focus'] = focus;
        this.allDatesData[dateIndex]['primaryTaskId'] = primaryTask.id;
        this.allDatesData[dateIndex]['primaryTaskStatus'] = primaryTask.status;
        this.allDatesData[dateIndex]['objectives'] = primaryTask.objectives;
        this.allDatesData[dateIndex]['isFirstTask'] = (this.successCompassDataService.dateObjectFromMillis(this.data.startDate,this.data.userTimezone).toFormat('yyyy LLL dd') === this.successCompassDataService.dateObjectFromMillis(primaryTask.taskStartDate,this.data.userTimezone).toFormat('yyyy LLL dd'));
        this.allDatesData[dateIndex]['primaryTaskStartDate'] = this.successCompassDataService.dateObjectFromMillis(primaryTask.taskStartDate,this.data.userTimezone);
        this.allDatesData[dateIndex]['primaryTaskEndDate'] = this.successCompassDataService.dateObjectFromMillis(primaryTask.taskEndDate,this.data.userTimezone);
        this.allDatesData[dateIndex]['primaryTaskTimeAlloted'] = null;
        if(subtask.humanCommitment != 0 && !isPrimaryTaskTimeAlloted){
          this.allDatesData[dateIndex]['primaryTaskTimeAlloted'] = primaryTask.humanCommitment;
          isPrimaryTaskTimeAlloted = true;
        }
      });
    });
    if(this.startDate == null){
      this.startDate = date;
    }
    this.limits.startDate = this.data.startDate?this.successCompassDataService.dateObjectFromMillis(this.data.startDate,this.data.userTimezone).toFormat('yyyy LLL dd'):null;
    this.limits.endDate = date.toFormat('yyyy LLL dd');
    this.calendarMonthDates();
  }

  calendarMonthDates(){
    this.dates = this.getCalendarDays(this.startDate);
    this.calendarDataFormat();
  }
  private getCalendarDays(date) {
    const calendarStartDate = this.getCalendarStartDay(date);
    return this.range(0, 6).map(num => calendarStartDate!.plus({'days': num}));
  }
  private getCalendarStartDay(date) {
    const firstDayOfMonth = date.startOf('week', {useLocaleWeeks: true});
    return this.range(0,6).map(num => firstDayOfMonth.minus({'days': num})).find(dt => dt.weekday === 7)
  }
  private range(start, end, length = end - start + 1) {
    return Array.from({ length }, (_, i) => start + i)
  }
  calendarDataFormat(){
    this.calendarData.length = 0;
    this.calendarData = [];
    this.dates.forEach((date,index) => {
      let obj = {
        date: date,
        isToday: date.toFormat('yyyy LLL dd') === this.successCompassDataService.now(this.data.userTimezone).toFormat('yyyy LLL dd'),
        data: this.allDatesData[date.toFormat('yyyy LLL dd')]
      };
      this.calendarData[index] = obj;
    });
  }
}
